export default {
  lookupWorkspace(workspaceId) {
    const obj = {
      actionType: appConstants.ActionTypes.LOOKUP_WORKSPACE,
      postData: {
        workspace_id: workspaceId,
      },
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
